import React from "react";
import "./CardPromotion.css";
import CampaignsList from "../../../components/CampaignsList";

const CardPromotion = () => {
  return (
    <div>
      <CampaignsList showOn="promotions" />
    </div>
  );
};

export default CardPromotion;
